import BasicDataTable from "../../Component/BasicComponents/BasicDataTable";
import { FaEye } from "react-icons/fa";
import PageHeader from "../../Component/BasicComponents/HeaderBreadCrumbs";
import { useLocation, useNavigate } from "react-router-dom";
import RoundedDropdown from "../../Component/BasicComponents/Dropdowns/RoundedDropdown";
import {
  useOnboardingOutletTypesData,
  useOnboardingStatusData,
  useOnboardRequestListData,
  useUpdateBulkOnboardRequest,
} from "./hooks/useOnBoard";
import { useState } from "react";
import { useGetTerritoryList } from "../FSM/Territories/UseTerriitory";
import RouteModal from "../../Component/BasicComponents/Modal/RouteModal";
import CustomInput from "../../Component/BasicComponents/CustomInput";
import { Btn } from "../../AbstractElements";
import { showToast } from "../../utils/toastUtils";
import CustomDropdown from "../../Component/BasicComponents/Dropdowns/RoundedDropdownPagination";
import { getTerritoryList } from "../FSM/Territories/TerritoryRepo";
import axiosInstance from "../../Api/axiosInstance";
import { API_ENDPOINTS } from "../../Api/apiEndPoints";
import { useExcelPolling } from "../../hooks/useExcelPolling";
import { COLORS } from "../../constants/colors";

const HeaderContent = ({
  statusOptions = [],
  onStatusChange = () => {},
  outletTypesOptions = [],
  outletTypeChange = () => {},
  territoriesChanges = () => {},
  territoriesOptions = [],
  operationsOptions = [],
  operationsChanges = () => [],
  filterState,
  setFilterState,
  Orgunitid,
}: {
  statusOptions: any[];
  onStatusChange: any;
  outletTypesOptions: any;
  outletTypeChange: any;
  territoriesChanges: any;
  territoriesOptions: any;
  operationsOptions: any;
  operationsChanges: any;
  filterState?: any;
  setFilterState?: any;
  Orgunitid?: any;
}) => {
  return (
    <div
      style={{
        marginBottom: "15px",
        display: "flex",
        justifyContent: "flex-end",
        gap: "12px",
      }}
    >
      {/* <RoundedDropdown
        options={territoriesOptions}
        onSelect={territoriesChanges}
        defaultLabel="All"
        width="auto"
        isShowHeading
        DropdownHeading="Territory"
        headingColor="#2e8dd3"
      /> */}
      <CustomDropdown
        key={Orgunitid}
        placeholder="All"
        DropdownLabel="Territory"
        value={filterState?.Territory}
        onChange={(id) => {
          setFilterState((prev: any) => ({
            ...prev,
            Territory: id,
            page: 1,
          }));
        }}
        fetchData={async ({ page, limit, search }) => {
          // ✅ Stop API call if Orgunitid is missing or invalid
          if (!Orgunitid) {
            return {
              data: [],
              hasMore: false,
            };
          }
          const res = await getTerritoryList({
            page,
            limit,
            search,
            OrgUnit: Orgunitid,
          });

          const rawData = res?.data?.data || {};

          console.log(
            "🚀 ~ OnboardingRequestByOrgunit.tsx:209 ~ rawData:",
            rawData
          );

          let formatted = rawData.map((item: any) => ({
            id: item.TerritoryId,
            label: `${item.TerritoryName} - ${item.TerritoryCode}`,
          }));

          // ✅ Add "All" only on the first page
          if (page === 1) {
            formatted = [{ id: "", label: "All" }, ...formatted];
          }

          const hasMore = Object.keys(rawData).length === limit;

          return {
            data: formatted,
            hasMore,
          };
        }}
        includeAllOption
      />
      <RoundedDropdown
        options={outletTypesOptions}
        onSelect={outletTypeChange}
        defaultLabel="All"
        width="auto"
        isShowHeading
        DropdownHeading="Outlet Type"
        headingColor="#2e8dd3"
      />
      <RoundedDropdown
        options={operationsOptions}
        onSelect={operationsChanges}
        defaultLabel="All"
        width="auto"
        isShowHeading
        DropdownHeading="Operations"
        headingColor="#2e8dd3"
      />
      <RoundedDropdown
        options={statusOptions}
        onSelect={onStatusChange}
        defaultLabel="All"
        width="auto"
        isShowHeading
        DropdownHeading="Status"
        headingColor="#2e8dd3"
      />
    </div>
  );
};

const OnboardingRequestByOrgUnit = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const Orgunitid = location.state.orgunitId.OrgunitId;

  const [filterState, setFiltersState] = useState({
    OrgUnitId: Orgunitid,
    OutletTypeId: "",
    Territory: "",
    Operations: "",
    OnBoardingStatus: "",
    search: "",
    start: 1,
    length: 10,
    sortColumn: "",
    sortOrder: "",
  });
  const [selectedRows, setSelectedRows] = useState<any[]>([]);
  const [selectAll, setSelectAll] = useState(false);
  const [isStatusModal, setIsStatusModal] = useState(false);
  const [modalStatus, setModalStatus] = useState("");
  const [description, setDescription] = useState("");
  const [legacyCode, setLegacyCode] = useState("");
    const [loadingExcel, setLoadingExcel] = useState<boolean>(false);
    const [excelStatus, setExcelStatus] = useState<string | null>("Loading..");
        const { startPolling, stopPolling } = useExcelPolling();

  const { mutate: updateStatusOnboardRequest } = useUpdateBulkOnboardRequest();

  // const handleViewClick = (row: any) => {
  //   navigate(
  //     `/onboarding/requests/onboardingRequestByOrgUnit/onboardingDetailView`,
  //     { state: { onboardingRequestID: row?.OnBoardRequestId } }
  //   );
  // };
  const handleViewClick = (row: any) => {
    navigate(
      `/onboarding/requests/onboardingRequestByOrgUnit/onboardingDetailView`,
      {
        state: {
          onboardingRequestID: row?.OnBoardRequestId,
          rowData: row, // ✅ pass the entire row object here
        },
      }
    );
  };

  const { data: onboardRequestListData, isLoading: onboardRequestListLoading } =
    useOnboardRequestListData({
      params: {
        OrgUnitId: filterState?.OrgUnitId,
        OutletTypeId: filterState?.OutletTypeId,
        Territory: filterState?.Territory,
        Operations: filterState?.Operations,
        OnBoardingStatus: filterState?.OnBoardingStatus,
        search: filterState?.search,
        start: filterState?.start,
        length: filterState?.length,
        sortColumn: "",
        sortOrder: "",
      },
      enable: !!Orgunitid,
    });

  const { data: onboardStatus } = useOnboardingStatusData({ enable: true });

  const { data: onboardOutletTypesData } = useOnboardingOutletTypesData({
    enable: true,
  });
  const {
    data: territoryData,
    isLoading,
    isSuccess,
  } = useGetTerritoryList({
    enable: true,
    params: {
      OrgUnit: "",
      search: "",
      page: 1,
      limit: 10,
    },
  });

  const territoriesOptions = territoryData?.data?.data.map((item: any) => ({
    id: item?.TerritoryId,
    label: item?.TerritoryName,
  }));

  const outletTypesOptions = onboardOutletTypesData?.data
    ? [
        { id: "", label: "All" },
        ...Object.entries(onboardOutletTypesData?.data || {}).map(
          (item: any) => ({
            id: item[0],
            label: item[1],
          })
        ),
      ]
    : [];

  const statusOptions = onboardStatus?.data?.OnBoardStatus
    ? [
        { id: "", label: "All" },
        ...Object.entries(onboardStatus.data.OnBoardStatus).map(
          ([key, value]) => ({
            id: key,
            label: value,
          })
        ),
      ]
    : [];
  const operationsOptions = onboardStatus?.data?.OnBoardAddressStatus
    ? [
        { id: "", label: "All" },
        ...Object.entries(onboardStatus?.data?.OnBoardAddressStatus).map(
          ([key, value]) => ({
            id: key,
            label: value,
          })
        ),
      ]
    : [];

  const statusMap = onboardStatus?.data?.OnBoardStatus || {};

  const handlePagination = (pageNo: number) => {
    setFiltersState((prevState: any) => {
      return {
        ...prevState,
        start: pageNo,
      };
    });
  };
  const handleonChangeRowsPerPage = (limit: any, pageNo: any) => {
    setFiltersState((prevState: any) => {
      return {
        ...prevState,
        start: pageNo,
        length: limit,
      };
    });
  };

  const handleSearch = (searchValue: any) => {
    setFiltersState((prevState: any) => {
      return {
        ...prevState,
        search: searchValue,
      };
    });
  };
  const handleRowSelect = (row: any) => {
    const isSelected = selectedRows.some(
      (selected) => selected.OnBoardRequestId === row.OnBoardRequestId
    );

    let updatedSelection;
    if (isSelected) {
      updatedSelection = selectedRows.filter(
        (selected) => selected.OnBoardRequestId !== row.OnBoardRequestId
      );
    } else {
      updatedSelection = [...selectedRows, row];
    }

    setSelectedRows(updatedSelection);

    // Update header checkbox
    const allRows = onboardRequestListData?.data?.data || [];
    setSelectAll(updatedSelection.length === allRows.length);
  };

  const isRowSelected = (row: any) => {
    return selectedRows.some(
      (selected) => selected.OnBoardRequestId === row.OnBoardRequestId
    );
  };

  const handleSelectAll = () => {
    const allRows = onboardRequestListData?.data?.data || []; // use your actual source of rows
    const selectableRows = allRows.filter(
      (row: any) => row.Status === 4 || row.Status === 5
    );

    const allSelected = selectableRows.every((row: any) => isRowSelected(row));

    if (allSelected) {
      // Deselect all eligible rows
      const remainingRows = selectedRows.filter(
        (row) => !(row.Status === 4 || row.Status === 5)
      );
      setSelectedRows(remainingRows);
      setSelectAll(false);
    } else {
      // Select only rows with status 4 or 5
      const updatedSelection = [
        ...selectedRows.filter(
          (row) => !(row.Status === 4 || row.Status === 5)
        ),
        ...selectableRows,
      ];
      setSelectedRows(updatedSelection);
      setSelectAll(true);
    }
  };

  const hasSelectableRows = onboardRequestListData?.data?.data.some(
    (row: any) => row.Status === 4 || row.Status === 5
  );

  const handleApproveBulkRequest = () => {
    setIsStatusModal(!isStatusModal);
    setModalStatus("approve");
  };

  const handleRemoveBulkRequest = () => {
    setIsStatusModal(!isStatusModal);
    setModalStatus("reject");
  };

  const toggleModal = () => {
    setIsStatusModal(false);
    setDescription("");
    setModalStatus("");
    setSelectedRows([]);
    setSelectAll(false);
    setLegacyCode("");
  };
  const handleClose = () => {
    setIsStatusModal(!isStatusModal);
    setDescription("");
    setModalStatus("");
    setSelectedRows([]);
    setSelectAll(false);
    setLegacyCode("");
  };

  const handleApproveRequest = () => {
    const ids = selectedRows.map((row) => row.OnBoardRequestId);

    if (!ids) {
      showToast.warning("Please select the Onboard Request!");
      return;
    } else if (!description.trim()) {
      showToast.warning("Please Fill the  Description Field !");
      return;
    } else {
      const approveBody = {
        ids: ids,
        action: "approve",
        Description: description,
        legacyCode: legacyCode,
      };
      updateStatusOnboardRequest(approveBody, {
        onSuccess: () => {
          handleClose();
        },
        onSettled: () => {
          handleClose();
        },
      });
    }
  };

  const handleRejectRequest = () => {
    const ids = selectedRows.map((row) => row.OnBoardRequestId);

    if (!ids) {
      showToast.warning("Please select the Onboard Request!");
      return;
    } else if (!description.trim()) {
      showToast.warning("Please Fill the  Description Field !");
      return;
    } else {
      const approveBody = {
        ids: ids,
        action: "reject",
        Description: description,
        legacyCode: "",
      };
      updateStatusOnboardRequest(approveBody, {
        onSuccess: () => {
          setDescription("");
          setIsStatusModal(false);
          setModalStatus("");
          setSelectedRows([]);
          setSelectAll(false);
          setLegacyCode("");
        },
        onSettled: () => {
          setDescription("");
          setIsStatusModal(false);
          setModalStatus("");
          setSelectedRows([]);
          setSelectAll(false);
          setLegacyCode("");
        },
      });
    }
  };

     const downloadExcelGet = async () => {
  const appToken = localStorage.getItem("Apptoken") || "";
    const OrgUnitId = filterState?.OrgUnitId || "";
    // const start = filterState?.start || "";
    // const length = filterState?.length || "";
    const search = filterState?.search || "";
    const Territory =filterState.Territory||"";
    const OutletTypeId =filterState.OutletTypeId||"";
    const OnBoardingStatus=filterState.OnBoardingStatus||"";
    const Operations=filterState.Operations||"";

    const params = new URLSearchParams();

    // Append only if the value exists
    if (OrgUnitId) params.append("orgUnitId", OrgUnitId);
    if (OutletTypeId) params.append("OutletTypeId", OutletTypeId);
    if (Operations) params.append("Operations", Operations);
    if (OnBoardingStatus) params.append("OnBoardingStatus", OnBoardingStatus);
    // if (start) params.append("start", String(start));
    // if (length) params.append("length", String(length));
    if (search) params.append("search", search);
    if (Territory) params.append("Territory", Territory);
     const queryString = new URLSearchParams(params).toString();
      try {
        setLoadingExcel(true);
        const response = await axiosInstance.get(
          `${API_ENDPOINTS.ONBOARDING.ONBOARDING_REQUEST_EXCEL}?${queryString}`
        );
        
        const { success, fileDownloadId, intervalTime } =
          response?.data?.data|| null;
  
        if (success && fileDownloadId) {
          startPolling(fileDownloadId, intervalTime, {
            onStatusUpdate: (currentStatus: string) => {
              setExcelStatus(currentStatus);
            },
            onSuccess: (url: any) => {
              setLoadingExcel(false);
              setExcelStatus('Loading..');
              const a = document.createElement("a");
              a.href = url;
              a.download = "report.xlsx";
              a.click();
              showToast.success("The file is ready!");
            },
            onFailed: (msg: any) => showToast.error(msg || ""),
            onExpired: (msg: any) => showToast.error(msg || ""),
            onDeleted: (msg: any) => showToast.error(msg || ""),
          });
        }
      } catch (err: any) {
        showToast.error(err);
      }
    };


  return (
    <div className="p-2">
      <PageHeader
        title="Onboarding Requests"
        buttons={[
          {
            label: "Approve Request",
            onClick: handleApproveBulkRequest,
            color: selectedRows.length === 0 && !selectAll ? "grey" : "#48AC1C",
            textColor: "#ffffff",
            disable: selectedRows.length === 0 && !selectAll,
          },
          {
            label: "Reject Request",
            onClick: handleRemoveBulkRequest,
            color: selectedRows.length === 0 && !selectAll ? "grey" : "#E32020",
            disable: selectedRows.length === 0 && !selectAll,
          },

            {
                     label: loadingExcel? excelStatus ? excelStatus.charAt(0).toUpperCase() + excelStatus.slice(1) +"..": "": "Excel",
                      onClick:downloadExcelGet,
                    color: loadingExcel ? COLORS.disable : COLORS.primary,
                                disable: loadingExcel ? true : false,
                     },
     
        ]}
      />
      <BasicDataTable
        Title="Category list"
        data={onboardRequestListData?.data?.data || []}
        showSpinner={onboardRequestListLoading}
        columns={OnboardingRequestByOrgUnitDataColumns(
          selectAll,
          handleSelectAll,
          handleViewClick,
          statusMap,
          handleRowSelect,
          isRowSelected,
          hasSelectableRows
        )}
        headerContent={
          <HeaderContent
            filterState={filterState}
            setFilterState={setFiltersState}
            statusOptions={statusOptions}
            outletTypesOptions={outletTypesOptions}
            territoriesOptions={territoriesOptions}
            operationsOptions={operationsOptions}
            operationsChanges={(e: any) =>
              setFiltersState((prev) => ({ ...prev, Operations: e.id }))
            }
            territoriesChanges={(e: any) =>
              setFiltersState((prev) => ({ ...prev, Territory: e.id }))
            }
            outletTypeChange={(e: any) =>
              setFiltersState((prev) => ({ ...prev, OutletTypeId: e.id }))
            }
            onStatusChange={(e: any) =>
              setFiltersState((prev) => ({
                ...prev,
                OnBoardingStatus: e.id,
              }))
            }
            Orgunitid={Orgunitid}
          />
        }
        onChangePage={(pageNo: number) => {
          handlePagination(pageNo);
        }}
        onChangeRowsPerPage={(newPerPage: any, page: any) => {
          handleonChangeRowsPerPage(newPerPage, page);
        }}
        handleSearch={(val: any) => {
          handleSearch(val);
        }}
        paginationTotalRows={onboardRequestListData?.data?.recordsTotal || 0}
      />
      <RouteModal
        isOpen={isStatusModal}
        toggle={toggleModal}
        title={
          modalStatus === "approve"
            ? "Approve Onboarding Request"
            : "Reject Onboarding Request"
        }
        size="md"
        content={
          <>
            {modalStatus === "approve" && (
              <CustomInput
                label="Leagacy Code"
                placeholder="Enter Legacy Code"
                type="text"
                // name="lastName"
                value={legacyCode}
                onChange={(e: any) => setLegacyCode(e.target.value)}
                // disabled={modalStatus === "reject"}
              />
            )}
            <CustomInput
              label="Description"
              placeholder="Enter Description"
              type="text"
              // name="lastName"
              value={description}
              asterisk={true}
              onChange={(e: any) => setDescription(e.target.value)}
            />
            <div className="d-flex justify-content-start mt-3 gap-2">
              {modalStatus === "approve" && (
                <Btn
                  style={{ backgroundColor: "#43B9B2", color: "white" }}
                  type="submit"
                  onClick={handleApproveRequest}
                >
                  Approve Request
                </Btn>
              )}
              {modalStatus === "reject" && (
                <Btn
                  style={{ backgroundColor: "#E32020", color: "white" }}
                  type="submit"
                  onClick={handleRejectRequest}
                  // disabled={buttonDisable}
                >
                  Reject Request
                </Btn>
              )}
              <Btn
                style={{
                  backgroundColor: "#F9FAFC",
                  color: "#000",
                  border: "1px solid #E0E0E0",
                }}
                type="button"
                onClick={handleClose}
              >
                Cancel
              </Btn>
            </div>
          </>
        }
      />
    </div>
  );
};

export default OnboardingRequestByOrgUnit;

const OnboardingRequestByOrgUnitDataColumns = (
  selectAll: boolean,
  handleSelectAll: () => void,
  handleViewClick: (row: any) => void,
  statusMap: Record<string, string>,
  handleRowSelect: (row: any) => void,
  isRowSelected: (row: any) => boolean,
  hasSelectableRows: boolean
) => [
  {
    name: hasSelectableRows ? (
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <input type="checkbox" checked={selectAll} onChange={handleSelectAll} />
      </div>
    ) : null,
    sortField: "Selected",
    selector: (row: any) =>
      row.Status === 4 || row.Status === 5 ? row.Selected : false,
    cell: (row: any) =>
      row.Status === 4 || row.Status === 5 ? (
        <input
          type="checkbox"
          checked={isRowSelected(row)}
          onChange={() => handleRowSelect(row)}
        />
      ) : null,
    ignoreRowClick: true,
    allowOverflow: true,
    button: true,
    minWidth: "50px",
    wrap: true,
    center: true,
  },
  {
    name: "Request ID",
    selector: (row: { OnBoardRequestId: string }) =>
      row.OnBoardRequestId || "-",
    sortable: true,
    minWidth: "135px",
    wrap: true,
  },
  {
    name: "Outlet Name",
    selector: (row: any) => {
      const firstname = row?.FirstName || "";
      const lastname = row?.LastName || "";
      const fullname = `${firstname} ${lastname}`;
      return row.OutletName ? row?.OutletName : fullname;
    },
    sortable: true,
    minWidth: "150px",
    wrap: true,
  },
  {
    name: "Outlet Type",
    selector: (row: { OutlettypeName: string }) => row.OutlettypeName || "-",
    sortable: true,
    minWidth: "150px",
    wrap: true,
  },
  {
    name: "Email",
    selector: (row: { Email: string }) => row.Email || "-",
    sortable: true,
    minWidth: "150px",
    wrap: true,
  },
  {
    name: "Mobile",
    selector: (row: { Mobile: string }) => row.Mobile || "-",
    sortable: true,
    minWidth: "120px",
    wrap: true,
  },
  {
    name: "Territory",
    selector: (row: { TerritoryName: string }) => row.TerritoryName || "-",
    sortable: true,
    minWidth: "140px",
    wrap: true,
  },
  {
    name: "Created at",
    selector: (row: { CreatedAt: string }) => row.CreatedAt || "-",
    sortable: true,
    minWidth: "150px",
    wrap: true,
  },
  {
    name: "Status",
    selector: (row: { Status: string | number }) =>
      statusMap?.[String(row.Status)] || row.Status || "-",
    sortable: true,
    minWidth: "140px",
    wrap: true,
  },
  {
    name: "Operations",
    selector: (row: { Operations: string }) => row.Operations || "-",
    sortable: true,
    minWidth: "150px",
    wrap: true,
  },
  {
    name: "Action",
    width: "100px",
    cell: (row: any) => (
      <div className="d-flex align-items-center gap-2">
        <button
          className="btn d-flex align-items-center justify-content-center gap-1"
          onClick={() => handleViewClick(row)}
          style={{
            backgroundColor: "#2e8dd3",
            color: "white",
            borderRadius: "20px",
            padding: "3px",
            width: "70px",
            border: "none",
          }}
        >
          <FaEye size={14} style={{ fill: "#fff" }} /> View
        </button>
      </div>
    ),
  },
];
